export enum EntityCardSection {
    CompanyMainInfo = 1,
    CompanyMainContact,
    CompanyAccountInfo,
    CompanyMainOffice,
    CompanyCustomInfo,
    ContactMainInfo,
    ContactCompanyInfo,
    ContactCustomInfo,
    BuildingMainInfo,
    BuildingAdditionalInfo,
    BuildingLocation,
    BuildingCustomInfo,
    OpportunityMainInfo,
    OpportunityOrganization,
    OpportunityDetails,
    OpportunityBuilding,
    OpportunityBidInfo,
    OpportunityCustomer,
    OpportunityContractingTeam,
    OpportunityCustomInfo,
    AccountMainInfo,
    AccountAdditionalInfo,
    AccountCustomInfo
}
